import {
  useSetNewPassword
} from 'hooks/useForgotPassword';

export function useSetNewPasswordPage() {

  const {isLoading: isSettingNewPassword, mutate: setNewPassword, isSuccess: hasSetNewPassword, isError: failedSettingNewPassword } = useSetNewPassword(); 
  
  return {
    isSettingNewPassword,
    setNewPassword,
    hasSetNewPassword,
    failedSettingNewPassword,
  }
  
}